export function SectionLayout({ children, className }) {
  const mobile = "my-20 px-5";
  const tablet = "md:my-[6.25rem] md:px-8";
  const desktop = "xl:my-[7.5rem]";
  const desktopInner = "max-w-[1170px]";

  const styles = `w-full ${mobile} ${tablet} ${desktop} ${className}`;
  const innerStyles = `mx-auto ${desktopInner}`;
  return (
    <section className={styles}>
      <div className={innerStyles}>{children}</div>
    </section>
  );
}
